import { Component, input, output, WritableSignal } from '@angular/core';
import { FormControl } from '@angular/forms';

import { AngularModule, MaterialModule } from '@shared/modules';
import { OptionSelectI } from './inpu-select.interface';

@Component({
  selector: 'app-input-select',
  standalone: true,
  imports: [AngularModule, MaterialModule],
  templateUrl: './input-select.component.html',
  styleUrl: './input-select.component.scss',
})
export class InputSelectComponent {
  label = input.required<string>();
  labelSelect = input.required<string>();
  value = input.required<string>();
  control = input.required<FormControl>();
  defaultOptions = input<OptionSelectI[]>([]);
  defaultValue = input.required<WritableSignal<OptionSelectI>>();
  isClear = input<boolean>(true);
  maxLength = input<number>(0);
  minLength = input<number>(0);

  clearInput = output<void>();
  minLengthError = output<void>();

  clear(): void {
    this.control().setValue('');
    this.clearInput.emit();
  }
}
